import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Img from '../../FeedImage/Img';
// import { generateSnapshotUrl } from '../../../utils';
import { removeTimestamp } from '../../../actions/takeSnapshot';
import { Loader } from '../../';
import SnapshotOutOfBoundsError from '../../../errors/SnapshotOutOfBoundsError';

import './snapshot-viewer.scss';

class SnapshotViewer extends Component {

  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
  }

  handleError() {
    this.props.dispatch(removeTimestamp(this.props.timestampIndex));
  }

  render() {
    const { count, snapshotData, recordingTemplate } = this.props;
    const counterClass = parseInt(count, 10) > 0 ? 'right' : 'left';
    const formattedCount = (count > 0 ? '+' : '') + count;

    if (snapshotData instanceof SnapshotOutOfBoundsError) {
      const data = {
        uri: window ? window.location.href : 'Window location not identified.',
        recordingTemplate,
        dateOfFailure: Math.floor(Date.now() / 1000),
        exceptionType: snapshotData.constructor.name,
        stackTrace: snapshotData.stack,
        exceptionMessage: snapshotData.toString(),
      };
      snapshotData.notify('Snapshot system failed.', `${data.exceptionType}:${data.recordingTemplate}`, data);

      return (
        <div style={{ padding: '2em', backgroundColor: 'white', textAlign: 'center' }}>
          <h2>We&apos;re Sorry</h2>
          <p>{snapshotData.message}</p>
        </div>
      );
    }

    return (
      <div className="snapshot-container">
        {count !== 0 && snapshotData &&
        <div className={`snapshot-counter-wrap ${counterClass}`}>
          <div className="snapshot-counter">{ formattedCount }</div>
        </div>
        }
        <div className="snapshot-viewer-wrapper">
          <div className={'snapshot-img active'}>
            <Img src={snapshotData.scaledUri} onError={this.handleError} className="img-fluid" />
            <Loader style={{ height: 250 }} dark />
          </div>
          <div className={'snapshot-img'} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    timeline: state.takeSnapshot.timeline,
    timestampIndex: state.takeSnapshot.timestampIndex,
    initialTimestamp: state.takeSnapshot.initialTimestamp,
    removedToggle: state.takeSnapshot.removedToggle,
  };
};

SnapshotViewer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  recordingTemplate: PropTypes.string,
  count: PropTypes.number.isRequired,
  timestampIndex: PropTypes.number,
  snapshotData: PropTypes.shape({}),
};

SnapshotViewer.defaultProps = {
  recordingTemplate: '',
  timestamp: null,
  counter: '',
  timestampIndex: null,
  snapshotData: {},
};

export default connect(mapStateToProps)(SnapshotViewer);
